// extracted by mini-css-extract-plugin
export default {"tabs":"ProjectTabs_tabs__OFesm","headerWrapper":"ProjectTabs_headerWrapper__3thjN"};